import script from "./AppTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppTab.vue?vue&type=script&setup=true&lang=ts"

import "./AppTab.vue?vue&type=style&index=0&id=70090884&lang=scss"

const __exports__ = script;

export default __exports__